import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Button, Card, CardActions, DialogContainer } from "react-md";
import moment from "moment";
import { values, isArray } from "lodash";
import classNames from "classnames";
import {
  RegistrationShape,
  MAX_USER_IN_GROUP,
  isMember,
  isInactive,
  isFlagged,
  getTierAndTypeFromRegistration,
  rangeLabelsMap,
} from "../../../utils";
import Members from "./Members";
import RegistrationCardTitle from "./RegistrationCardTitle";
import GroupRegistrationButton from "./GroupRegistrationButton";

class Registration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDeleteDialogVisible: false,
      confirmUnGroupDialogVisible: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleUnGroup = this.handleUnGroup.bind(this);
    this.openConfirmDeleteDialog = this.openConfirmDeleteDialog.bind(this);
    this.openConfirmUnGroupDialog = this.openConfirmUnGroupDialog.bind(this);
    this.closeConfirmDeleteDialog = this.closeConfirmDeleteDialog.bind(this);
    this.closeConfirmUnGroupDialog = this.closeConfirmUnGroupDialog.bind(this);
    this.handleTitleClick = this.handleTitleClick.bind(this);
    this.handleIconClick = this.handleIconClick.bind(this);
  }

  handleClick() {
    const { registration, selectedUserInQueue, rangeLocation } = this.props;
    const { onSelectUserInQueue, onOpenQueueItemDetail } = this.props;

    if (isFlagged(registration)) {
      onOpenQueueItemDetail(rangeLocation, registration);
    } else {
      onSelectUserInQueue(rangeLocation, selectedUserInQueue, registration);
    }
  }

  handleDelete(event) {
    event.stopPropagation();
    const { onDelete, rangeLocation, registration } = this.props;
    onDelete(rangeLocation, registration.registrationId);
  }

  handleUnGroup(event) {
    event.stopPropagation();
    const { onUnGroupRegistration, rangeLocation, registration } = this.props;
    onUnGroupRegistration(rangeLocation, registration);
    this.setState(() => ({
      confirmUnGroupDialogVisible: false,
    }));
  }

  openConfirmDeleteDialog(event) {
    event.stopPropagation();
    this.setState(() => ({
      confirmDeleteDialogVisible: true,
    }));
  }

  closeConfirmDeleteDialog() {
    this.setState(() => ({
      confirmDeleteDialogVisible: false,
    }));
  }

  openConfirmUnGroupDialog(event) {
    event.stopPropagation();
    this.setState(() => ({
      confirmUnGroupDialogVisible: true,
    }));
  }

  closeConfirmUnGroupDialog(event) {
    event.stopPropagation();
    this.setState(() => ({
      confirmUnGroupDialogVisible: false,
    }));
  }

  handleTitleClick(event) {
    // stop event so the drawer doesn't open
    event.stopPropagation();

    // redirect to customer page of main user
    const { history, registration } = this.props;
    history.push(`/customer/${registration.group[0].customer}`);
  }

  handleIconClick() {
    // when select icon, whenever user is flagged or not open right drawer
    // so with non-flagged user, we can change user's registration

    const { onOpenQueueItemDetail, rangeLocation, registration } = this.props;
    onOpenQueueItemDetail(rangeLocation, registration);
  }

  render() {
    const {
      selected,
      registration,
      selectedUserInQueue,
      registrationIsGrouped,
    } = this.props;

    const { tier, type } = getTierAndTypeFromRegistration(registration);
    const ranges = Object.keys(registration.ranges || {})
      .filter((key) => registration.ranges[key])
      .map((key) => rangeLabelsMap[key]);

    let requirements = registration.rental ? ranges.concat("rental") : ranges;
    requirements = requirements.map((r) => r.toUpperCase());

    const registrationDuration = moment
      .duration(moment().diff(registration.timestamp))
      .humanize();

    const group = isArray(registration.group)
      ? registration.group
      : values(registration.group);
    //exclude main user
    const groupMembers = group.length > 1 ? group.slice(1) : [];

    const thereIsSelectedRegistration =
      !!selectedUserInQueue &&
      !isFlagged(selectedUserInQueue) &&
      !isFlagged(registration) &&
      selectedUserInQueue.registrationId !== registration.registrationId;

    const overMaxMember =
      selectedUserInQueue &&
      registration.group.length + selectedUserInQueue.group.length >
        MAX_USER_IN_GROUP;

    const mainUser = `${(group[0] || {}).firstName} ${
      (group[0] || {}).lastName
    }`;
    return (
      <Card
        className={classNames("queue-item", "md-paper--3", {
          "queue-item--selected": selected,
        })}
        onClick={this.handleClick}
      >
        <RegistrationCardTitle
          onIconClick={this.handleIconClick}
          onTitleClick={this.handleTitleClick}
          isMember={isMember(registration)}
          membershipTier={tier}
          membershipType={type}
          isInactive={isInactive(registration)}
          flagged={isFlagged(registration)}
          mainUser={mainUser}
          requirements={requirements.join(", ")}
          registrationDuration={registrationDuration}
        />
        <Members members={groupMembers} />
        <CardActions>
          {registrationIsGrouped ? (
            <Button
              flat
              label="Un Group"
              className="un-group-registration-button"
              onClick={this.openConfirmUnGroupDialog}
            />
          ) : (
            <GroupRegistrationButton
              thereIsSelectedRegistration={thereIsSelectedRegistration}
              overMaxMember={overMaxMember}
            />
          )}
          <Button
            flat
            className="md-btn--warning queue-item--delete-button"
            label="Remove"
            onClick={this.openConfirmDeleteDialog}
          />
        </CardActions>
        <DialogContainer
          id="confirmDelete"
          visible={this.state.confirmDeleteDialogVisible}
          title="Delete confirmation!"
          onHide={this.closeConfirmDeleteDialog}
          aria-labelledby="confirmDeleteDescription"
          modal
          dialogStyle={{ width: 390 }}
          actions={[
            {
              onClick: this.closeConfirmDeleteDialog,
              label: "Cancel",
            },
            {
              onClick: this.handleDelete,
              secondary: true,
              label: "Delete",
            },
          ]}
        >
          <p id="confirmDeleteDescription" className="md-color--secondary-text">
            Do you want to delete {`'${mainUser}'`} registration?
          </p>
        </DialogContainer>
        <DialogContainer
          id="confirmUnGroup"
          visible={this.state.confirmUnGroupDialogVisible}
          title="Un Group confirmation!"
          onHide={this.closeConfirmUnGroupDialog}
          aria-labelledby="confirmUnGroupDescription"
          modal
          dialogStyle={{ width: 390 }}
          actions={[
            {
              onClick: this.closeConfirmUnGroupDialog,
              label: "Cancel",
            },
            {
              onClick: this.handleUnGroup,
              secondary: true,
              label: "Un Group",
            },
          ]}
        >
          <p
            id="confirmUnGroupDescription"
            className="md-color--secondary-text"
          >
            Do you want to un group {`'${mainUser}'`} registration?
          </p>
        </DialogContainer>
      </Card>
    );
  }
}

Registration.propTypes = {
  registration: RegistrationShape.isRequired,
  selectedUserInQueue: RegistrationShape,
  rangeLocation: PropTypes.string.isRequired,
  onSelectUserInQueue: PropTypes.func.isRequired,
  onUnGroupRegistration: PropTypes.func.isRequired,
  onOpenQueueItemDetail: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  registrationIsGrouped: PropTypes.bool.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }),
};

Registration.defaultProps = {
  selectedUserInQueue: null,
};

export default withRouter(Registration);



// WEBPACK FOOTER //
// ./src/staff/components/Queue/Registration/Registration.jsx